<template>
  <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2">
    <div class="row margenes">
      <div class="sec_imagen"> 
        <img :src="require(`@/assets/imagenes/${imgSrc}`)" :alt="imgAlt">  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
      required: true
    }

  }
};
</script>